const request = require('superagent');

const CountryAPI = {
    getCountryList: (params) => request
        .get(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v1/countries?q[${params.availableName}]=true${params.zoneId !== undefined ? `&zone_id=${params.zoneId}` : ''}`)
        .query({ per_page: 300 })
        .set('Accept', 'application/json')
        .send(),

    getStatesByCountry: (params) => request
        // eslint-disable-next-line max-len
        .get(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v1/states?${params.currentZone ? `zone_id=${params.currentZone}` : ''}&country_id=${params.countryId}&q[${params.availableName}]=true`)
        .query({ per_page: 300 })
        .set('Accept', 'application/json')
        .send(),

    getMunicipalityList: (params) => request
        .get(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v1/cities?country=${params.countryId}&state=${params.stateCode}`)
        .query({ per_page: 300 })
        .set('Accept', 'application/json')
        .send(),
};

export default CountryAPI;



/** WEBPACK FOOTER **
 ** ./src/apis/country.js
 **/